import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

import DocumentVerification from '../../../components/siteadmin/DocumentVerification';
import Loader from '../../../components/Loader';

import showAllDocumentQuery from './showAllDocumentQuery.graphql';

import s from './Document.css';
import { withQuery } from '../../../hoc/withGraphql';

const Document = (props) => {

  const [state, setState] = useState({ currentPage: 1, searchList: '' });

  const setStateVariable = (variables) => {
    setState(prev => ({
      ...prev,
      ...variables
    }));
  };

  const { data: { loading, showAllDocument, refetch }, title } = props;
  const { searchList, currentPage } = state;

  if (loading) {
    return <Loader type={"text"} />;
  } else {
    return <DocumentVerification showAllDocument={showAllDocument} searchList={searchList} currentPage={currentPage} refetch={refetch} setStateVariable={setStateVariable} title={title} />;
  }
}

Document.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.shape({
    loading: PropTypes.bool,
    getAllDocument: PropTypes.array,
  })
};

Document.defaultProps = {
  data: {
    loading: true
  }
};

export default compose(
  withStyles(s),
  withQuery(showAllDocumentQuery, {
    options: (props) => ({
      fetchPolicy: 'network-only',
      ssr: false
    })
  }),
)(Document);